module.exports = __webpack_public_path__ + "img/BgPink@2x.7b90249e.png";